// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section1 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section one'>
       <div className="wrapper">
        <h2 style={{marginTop: '0'}}>So viele Hunde gibt es in der Schweiz</h2>
        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                Die Zahl der Hunde, die hierzulande leben, ist genau bekannt. Denn es gilt eine Registrierungspflicht. Ende Februar zählte die Datenbank 556’543 Tiere – fast 13 Prozent mehr als noch vor sieben Jahren. Damit ist die Zahl der Hunde stärker gewachsen als die Schweizer Bevölkerung. Auf 16 Einwohnerinnen und Einwohner kommt heute ein Hund.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/DbsKw/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className='txt'>
                Die Pandemie hat diesen <Stink href='419487462223'>Trend noch verstärkt</Stink>. 2020 und 2021 stieg der Hundebestand deutlich stärker als in den Vorjahren, weil sich wegen der Corona-Einschränkungen viele Menschen allein fühlten und mit einem Haustier offenbar diese Lücke füllen wollten. Statt durchschnittlich 6000 wurden plötzlich mehr als 15'000 Hunde pro Jahr neu angeschafft.
              </div>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/vyP1p/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>

              <div className='txt'>
                <p>
                  Im vergangenen Jahr hat sich dieser Corona-Effekt fortgesetzt, aber schon leicht abgeschwächt. Und vielleicht kommt es nun zu einer Trendwende: Im Dezember 2022 und Januar 2023 ging die Zahl der registrierten Hunde erstmals seit Beginn der Pandemie wieder in zwei aufeinanderfolgenden Monaten zurück.
                </p>
              </div>
            </div>
        </div>
      </div>
    </div>
  }
}
